import store from "@/store/index";
export const windowBlur = () => store.dispatch("pauseAnimation");
export const loadProgress = (res) => {
    store.dispatch('audio', {
		downloading: true,
        loaded: 0
	})
    return new Response(
        new ReadableStream({
            start(controller){
                const reader = res.body.getReader();	
                read();
                function read(){
                    reader.read()
                    .then(progressEvent => {
                        if(progressEvent.done === true){
                            controller.close();
                            store.dispatch('audio', { downloading: false })
                            return;
                        }
                        store.dispatch('audio', { loaded: store.getters.audio.value.loaded + progressEvent.value.byteLength })
                        controller.enqueue(progressEvent.value);
                        read();
                    })
                }

            }
        })
    )
}
